import type React from "react"

interface AuthLayoutProps {
  children: React.ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Auth Form */}
      <div className="flex-1 flex items-center justify-center p-6 lg:p-8">
        <div className="w-full max-w-md">{children}</div>
      </div>

      {/* Right side - Branding */}
      <div className="hidden lg:flex flex-1 items-end justify-center relative overflow-hidden">
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/images/auth-background.png')",
          }}
        />

        {/* Content overlay */}
        <div className="relative z-10 text-center text-white pb-16 px-8">
          <div className="mb-6">
            <img src="/images/app-logo.svg" alt="THAISLIPCHECK" className="w-80 mx-auto" />
          </div>

          <div className="space-y-2 text-lg">
            <p className="font-medium text-brand-text-base">
              ตรวจสอบ<span className="font-bold text-white">สลิปแท้</span> ป้องกัน
              <span className="text-brand-red font-bold">สลิปปลอม</span>
            </p>
            <p className="text-white">
              ตรวจสอบได้ทันที ตลอด<span className="text-brand-red font-bold">24ชม.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
